import React, { useContext, useEffect } from 'react';
import { AppContext } from './context/AppContext';
import recordEvent from './helperFunctions';
import { useNavigate } from 'react-router-dom';

function GoaliesMain(props) {
    const { FLAGS, timer, events, setEvents,
        period, goalies, setGoalies } = useContext(AppContext);

    useEffect(() => {
        // every time I go to the main page, close the popup
        props.hideHamburger();
    }, [])

    const navigate = useNavigate();

    function saveGoalies() {
        if (FLAGS.debug === true) {
            console.log('truying to saveGoalies')
        }
        recordEvent(timer, period, events, setEvents,
            'SetGoalies '
            + 'Home[' + goalies.home + ']'
            + 'Visitor[' + goalies.visitor + ']'
        );
        // need to call the event to save the goalies
        navigate('/');
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setGoalies(prevStruct => ({
            ...prevStruct,
            [name]: value
        }));
    };
    function pullGoalie(name) {
        console.log('Goalie Pulled: ' + name)
        setGoalies(prevStruct => ({
            ...prevStruct,
            [name]: 'Pulled'
        }));

    }
    return (
        <div>
            <h1>Goalies</h1>
            <div className="editTeamNames">
                <div className='TeamInfoCard'>
                    <div>Home Goalie</div>
                    <input type='text' onInput={handleChange} name='home'
                        placeholder="Enter Home Goalie"
                        value={goalies.home} />
                    <button onClick={() => pullGoalie('home')}>Pull Home</button>

                </div>
                <div className='TeamInfoCard'>
                    <div>Visitor Goalie</div>
                    <input type='text' onInput={handleChange} name='visitor'
                        placeholder="Enter Visitor Goalie"
                        value={goalies.visitor} />
                    <button onClick={() => pullGoalie('visitor')}>Pull Vistor</button>

                </div>


            </div>
            <button className='save' onClick={saveGoalies}>Save Goalies</button>
        </div >
    );
}

export default GoaliesMain;